module.exports = __webpack_public_path__ + "images/molenaar409e22779c2ce8888f2a50b79ef3dce5.png";